import C from '../constants';
import { ConceptFeedbackApi } from '../../Shared';

const api = new ConceptFeedbackApi('connect');

const actions = {
  // called when the app starts. this means we immediately download all quotes, and
  // then receive all quotes again as soon as anyone changes anything.
  startListeningToConceptsFeedback() {
    return function (dispatch, getState) {
      dispatch(actions.loadConceptsFeedback())
    };
  },
  loadConceptsFeedback() {
    return function (dispatch, getState) {
      api.getAll().then((data) => {
        dispatch({ type: C.RECEIVE_CONCEPTS_FEEDBACK_DATA, data: data, });
      });
    };
  },
  loadTranslatedConceptsFeedback(language) {
    return function (dispatch, getState) {
      api.getAll(language).then((data) => {
        dispatch({ type: C.RECEIVE_TRANSLATED_CONCEPTS_FEEDBACK_DATA, data: data, });
      });
    };
  },
  loadConceptFeedback(uid) {
    return function (dispatch, getState) {
      api.get(uid).then((data) => {
        dispatch({ type: C.RECEIVE_CONCEPT_FEEDBACK_DATA, uid: uid, data: data, });
      });
    };
  },
  startConceptsFeedbackEdit(cid) {
    return { type: C.START_CONCEPTS_FEEDBACK_EDIT, cid, };
  },
  cancelConceptsFeedbackEdit(cid) {
    return { type: C.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, };
  },
  deleteConceptsFeedback(cid) {
    return function (dispatch, getState) {
      dispatch({ type: C.SUBMIT_CONCEPTS_FEEDBACK_EDIT, cid, });
      api.remove(cid).then(() => {
        dispatch({ type: C.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
        dispatch({ type: C.DISPLAY_MESSAGE, message: 'ConceptsFeedback successfully deleted!', });
        dispatch(actions.loadConceptsFeedback())
      }).catch((error) => {
        dispatch({ type: C.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
        dispatch({ type: C.DISPLAY_ERROR, error: `Deletion failed! ${error}`, });
      })
    };
  },
  submitConceptsFeedbackEdit(cid, content) {
    return function (dispatch, getState) {
      dispatch({ type: C.SUBMIT_CONCEPTS_FEEDBACK_EDIT, cid, });
      api.update(cid, content).then(() => {
        dispatch(actions.loadConceptFeedback(cid))
        dispatch({ type: C.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
        alert("Update successfully saved!");
      }).catch((error) => {
        dispatch({ type: C.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
        dispatch({ type: C.DISPLAY_ERROR, error: `Update failed! ${error}`, });
      })
    };
  },
  testFeedback() {
  },
};

export default actions;
